import React, { useState } from 'react';

import { Button, Modal, Text } from '@shared/components/bootstrap';
import { Currency } from '@shared/components/helpers';

import { IInvoiceActionProps, IInvoiceActionFormProps } from '@admin/components/billing/invoices/types';

import { InvoiceForgiveForm } from './forgive/form';

const ForgiveModal: React.FC<IInvoiceActionFormProps> = (props) => (
  <Modal centered onClose={props.onCancel}>
    <Modal.Content>
      <Modal.Header>
        <Modal.Title>Forgive Invoice #{props.invoiceID}</Modal.Title>
        <Text tag="p">
          Amount Due: <Currency value={props.amountOwed} />
        </Text>
        <Modal.Close close={props.onCancel} />
      </Modal.Header>
      <Modal.Body>
        <InvoiceForgiveForm {...props} />
      </Modal.Body>
    </Modal.Content>
  </Modal>
);

export const Forgive: React.FC<IInvoiceActionProps> = ({ invoiceID, accountID, amountOwed, onSave }) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      <Button kind="danger" onClick={() => setShowModal(true)}>
        Forgive
      </Button>
      {showModal && (
        <ForgiveModal
          onCancel={() => setShowModal(false)}
          onSave={(attemptID) => {
            setShowModal(false);
            onSave(attemptID, 'Invoice successfully forgiven');
          }}
          invoiceID={String(invoiceID)}
          accountID={String(accountID)}
          amountOwed={Number(amountOwed)}
        />
      )}
    </>
  );
};
